import { colors } from 'app/styles/colors'
import PropTypes from 'prop-types'

export default PropTypes.oneOf(Object.keys(colors))
